<template>
    <component
        :is="target === '_blank'
        ? 'a'
        : tag"
        class="link" 
        :class="[
            {'link--muted': muted,
            'link--underlined': underlined,
            'link--line': inLine},
            outputClass
        ]"
        :href="tag === 'a' ? path : '#'"
        :to="tag === 'router-link' ? path || {} : ''"
        :target="target"
        >
        <span class="link__text" v-if="text.length">
            {{ text }}
        </span>
        <slot />
    </component>
</template>

<script>
const SIZES = ['normal', 'average'];
const TAGS = ['a', 'router-link', 'span'];

export default {
    name: 'BaseLink',
    props: {
        tag: {
            type: String,
            required: false,
            default: 'router-link',
            validator: function(tag) {
                return tag ? TAGS.includes(tag) : true
            }
        },
        text: {
            type: String,
            required: false,
            default: '',
        },
        path: {
            type: String,
            required: false,
            default: null
        },
        target: {
            type: String,
            required: false,
            default: '_self'
        },
        muted: {
            type: Boolean,
            required: false,
            default: false
        },
        inLine: {
          type: Boolean,
          required: false,
          default: false
        },
        underlined: {
            type: Boolean,
            required: false,
            default: false
        },
        size: {
            type: String,
            required: false,
            default: 'normal',
            validator: function(size) {
                return size ? SIZES.includes(size) : true;
            }
        }
    },
    computed: {
        sizeClass() {
            return `link--size-${this.size}`
        },
        outputClass() {
            return `${this.sizeClass}`
        }
    }
}
</script>

<style scoped lang="scss">
.link {
    display: inline-block;
    padding: 0;

    cursor: pointer;
    text-decoration: none;
    transition: color $transition-duration $transition-function;

    color: $primary;

    &:hover {
        text-decoration: underline;

        color: $primary;
    }

    &__text {
        color: inherit;
    }

    // sizes
    //16
    &--size-normal {
        @include text-normal($font-weight-regular, $line-height-medium);

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }

    //20
    &--size-average {
        @include text-average($font-weight-regular, $line-height-normal);
    }

    &--muted {
        color: rgba($primary, .5);
    }

    &--line {
      padding-top: 16px;
    }

    &--underlined {
        text-decoration-line: underline;
    }
}
</style>